import { render, staticRenderFns } from "./ModalInviteMember.vue?vue&type=template&id=60cd340d&"
import script from "./ModalInviteMember.vue?vue&type=script&lang=js&"
export * from "./ModalInviteMember.vue?vue&type=script&lang=js&"
import style0 from "./ModalInviteMember.vue?vue&type=style&index=0&id=60cd340d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports